
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationLabel as ObiLocationLabelElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-label.js';
 
 
 

 
 export const ObiLocationLabel = createComponent({
   react: React,
   tagName: 'obi-location-label',
   elementClass: ObiLocationLabelElement,
   events: {
     
   }
  });
 
 